<nb-layout [center]="layout.id === 'center-column'" windowMode>
  <nb-layout-header headroom fixed *ngIf="carregouUsuario">
    <ngx-header [position]="sidebar.id === 'start' ? 'normal': 'inverse'" [usuario]="usuariolayout"
      [NomeAgencia]="agencia ? agencia.NomeFantasia : '' "></ngx-header>
  </nb-layout-header>

  <nb-sidebar class="menu-sidebar" tag="menu-sidebar" responsive [end]="sidebar.id === 'end'">
    <nb-sidebar-header *ngIf="currentTheme !== 'corporate'" style="position: relative;height: auto !important;"
      class="pt-2">
      <div *ngIf="Logo != '/assets/img/notfound.jpg'" class="logo-agencia"
        style="display:flex;transform: translate(-50%, -50%);top: 50%;left: 50%;" class="col-12">
        <img class="img-fluid" src="{{Logo}}" style="margin-bottom: 25px;" />
      </div>
      <div class="col-12 pt-2 pb-2" style="margin: 20px 0 10px 0;">
        <div class="col-10 pr-0 nome-agencia">

          <strong>{{usuariolayout.Agencia ? usuariolayout.Agencia.NomeFantasia :
            usuariolayout.Empresa.NomeFantasia}}</strong>
          <div *ngIf="usuariolayout.Agencia == null">
            <!-- <div class="nome-agencia mt-2 mb-2" *ngIf="agencia != null">
              {{agencia.NomeFantasia}}
            </div> -->
            <a role="button" class="mr-1 botao-agencia" (click)="abrirModal(contentTrocarAgencia)"
              title="Alterar Agência">{{agencia != null ? ('Alterar' | translate) : ('Agência' | translate)}}</a>
            <a class="botao-agencia" *ngIf="agencia != null" (click)="limparAgencia()" [title]="'Limpar Agência' | translate">{{"Limpar" | translate}}</a>
          </div>
        </div>
      </div>
    </nb-sidebar-header>

    <div class="col-12 d-block d-lg-none my-3" *ngIf="dadosCambio" style="color: white">
      <div class="row">
        <div class="col-12 mb-2" style="font-weight: bold;">{{ 'Cotações' | translate }}</div>
      </div>
      <ul class="row pl-2">
        <li class="col-12" *ngFor="let dado of dadosCambio, let i = index">
          {{dado.MoedaDestino.Simbolo}}:
          {{dado.Taxas[0]?.Taxa | currency: 'BRL':'':'1.2-2'}}
        </li>
      </ul>
      <div class="row">
        <small class="col">
          {{ 'Atualizado em' | translate }}:
          {{ dadosCambio[0]?.Taxas[0]?.Alteracoes.CriadoEm | date: 'dd/MM/yyyy' }}
        </small>
      </div>
    </div>
    <ng-content select="nb-menu"></ng-content>
  </nb-sidebar>

  <nb-layout-column class="main-content">
    <ng-content select="router-outlet"></ng-content>
  </nb-layout-column>

  <nb-layout-column start class="small" *ngIf="layout.id === 'two-column' || layout.id === 'three-column'">
    <nb-menu [items]="subMenu"></nb-menu>
  </nb-layout-column>

  <nb-layout-column class="small" *ngIf="layout.id === 'three-column'">
    <nb-menu [items]="subMenu"></nb-menu>
  </nb-layout-column>

  <nb-layout-footer fixed>
    <ngx-footer></ngx-footer>
  </nb-layout-footer>

  <nb-sidebar class="settings-sidebar" tag="settings-sidebar" state="collapsed" fixed [end]="sidebar.id !== 'end'">
    <ngx-theme-settings></ngx-theme-settings>
  </nb-sidebar>
</nb-layout>

<ng-template #contentTrocarAgencia let-modal>
  <agencia-selecionar (selecionou)="trocarAgencia($event)"></agencia-selecionar>
</ng-template>